import classes from './ButtonWithConfirmation.module.scss';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Portal from '../Dropdown/Portal/Portal';
import Button from './Button/Button';
import Popup from './Popup/Popup';
import Text from '../typography/Text/Text';

function ButtonWithConfirmation(props) {
  const {
    onClick,
    onButtonClick,
    onCancel,
    className,
    buttonClassName,
    children,
    confirmation,
    confirmationTitle,
    confirmButtonText,
    cancelButtonText,
    popupClassNames: {
      baseClassName,
      headerClassName,
      bodyClassName,
      footerClassName
    } = {},
    ...other
  } = props;
  const [opened, setOpened] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);

  function onClickCapture(event) {
    if (onButtonClick) {
      onButtonClick(event);
    }
    setOpened(true);
  }

  function onClose(event) {
    if (onCancel) {
      onCancel(event);
    }
    setOpened(false);
  }

  async function onOk(event) {
    setIsConfirming(true);
    await onClick(event);
    setOpened(false);
    setIsConfirming(false);
  }

  return (
    <div className={className}>
      <Button
        className={cn(classes.button, buttonClassName)}
        onClick={onClickCapture}
        {...other}
      >
        {children}
      </Button>
      {opened && (
        <Portal>
          <Popup className={cn(classes.popup, baseClassName)} onClose={onClose}>
            <Popup.Header className={headerClassName}>
              {confirmationTitle}
            </Popup.Header>

            <Popup.Body className={bodyClassName}>
              <Text className={classes.text} block>
                {confirmation}
              </Text>
            </Popup.Body>

            <Popup.Footer
              okButtonText={confirmButtonText}
              onOK={onOk}
              cancelButtonText={cancelButtonText}
              onCancel={onClose}
              okButtonProps={{ loading: isConfirming }}
              okDisabled={isConfirming}
              cancelDisabled={isConfirming}
              className={footerClassName}
            />
          </Popup>
        </Portal>
      )}
    </div>
  );
}

ButtonWithConfirmation.propTypes = {
  onClick: PropTypes.func.isRequired,
  onButtonClick: PropTypes.func,
  onCancel: PropTypes.func,
  confirmationTitle: PropTypes.string.isRequired,
  confirmation: PropTypes.any.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  children: PropTypes.any,
  popupClassNames: PropTypes.shape({
    baseClassName: PropTypes.string,
    headerClassName: PropTypes.string,
    bodyClassName: PropTypes.string,
    footerClassName: PropTypes.string
  })
};

export default ButtonWithConfirmation;
